import React from 'react';
import { Modal } from 'antd';
import SharingContent from './SharingContent';
import * as CONSTANT from '../constant';

interface Props {
  title: string;
  visible: boolean;
  url: string;
  id: string;
  isFetching: boolean;
  hide: () => void;
  showEmail?: boolean;
  cid?: string;
}

const SharingModal: React.FC<Props> = ({
  title,
  visible,
  url,
  id,
  isFetching,
  hide,
  showEmail = true,
  cid,
}) => (
  <Modal
    open={visible}
    title={CONSTANT.MODAL_TITLE}
    footer={null}
    onCancel={hide}
    maskClosable={false}
  >
    <SharingContent
      title={title}
      url={url}
      id={id}
      isFetching={isFetching}
      hide={hide}
      open={visible}
      showEmail={showEmail}
      cid={cid}
    />
  </Modal>
);

export default SharingModal;
